module.exports = __webpack_public_path__ + "static/media/step_two.7e111d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-flight/landing/steps/step_two.png
// module id = 1413
// module chunks = 0